import React from 'react';
import { Box, Typography } from '@mui/material';
import { GrantsProps } from '../../types/props';

export const Grants: React.FC<GrantsProps> = ({ fiscalSponsorId }) => {
  return (
    <Box>
      <Typography variant="h4">Grants</Typography>
    </Box>
  );
}; 